export const ACELERACION_GRAVEDAD=9.81
export const UMBRAL_DE_DESVIACION = 4

/** |v| (m/s) por debajo de la cual la velocidad se considera “en reposo” para cerrar la fase de aterrizaje (CMJ). */
export const CMJ_ATERRIZAJE_VELOCIDAD_UMBRAL_MS = 0.05

/** Muestras consecutivas dentro del umbral de velocidad requeridas para fijar el fin de aterrizaje (CMJ). */
export const CMJ_ATERRIZAJE_VELOCIDAD_MUESTRAS_ESTABLES = 15

/** Fuerza combinada por debajo de esta fracción del peso corporal → despegue / vuelo (CMJ). */
export const CMJ_UMBRAL_PESO_FRACCION = 0.05

export const EVENT_BLE='EVENT_BLE'

/** Duración máxima de grabación por defecto (segundos). */
export const DURACION_MAX_PRUEBA_SEG_DEFAULT = 60;

/**
 * Duración máxima permitida de una grabación según la institución del atleta.
 * @param {object} [atletaDoc] - documento atleta con `institucion` poblada `{ nombre }` o solo ObjectId
 */
export function maxDuracionPruebaSegundos(atletaDoc) {
    if (!atletaDoc?.institucion || typeof atletaDoc.institucion !== "object") {
        return DURACION_MAX_PRUEBA_SEG_DEFAULT;
    }
    const nom = String(atletaDoc.institucion.nombre ?? "")
        .trim()
        .toLowerCase();
    if (nom.includes("brasil")) {
        return 90;
    }
    return DURACION_MAX_PRUEBA_SEG_DEFAULT;
}

